/* eslint-disable camelcase */
import ObjectUtils from '@spothero/utils/object';
import {formatPrice} from 'utils/number-format';
import {cpServiceGet} from 'api';
import {sendSentryException} from 'utils/error-handling';

/**
 * Formats the facility microclimate response
 * @function formatFacilityMarketSnapshotResponse
 * @param {MarketSnapshotData} data
 * @returns {MarketSnapshotData} The formatted facility details
 *
 * @memberof module:api/facilities/dto
 */
export const formatFacilityMarketSnapshotResponse = (data) => {
    if (!data) {
        return [];
    }

    const formattedData = ObjectUtils.camelizeKeys(data).map((item) => ({
        ...item,
        minRange: formatPrice(item.minRange),
        maxRange: formatPrice(item.maxRange),
        averageRate: formatPrice(item.averageRate),
    }));

    return formattedData;
};

/**
 * Gets the facility microclimate data
 * @param {number|string} facilityId - The facility id.
 * @returns {Promise<MarketSnapshotData[]>}
 * @throws {Error}
 *
 * @see '/control-panel-service/v1/facilities/{facilityId}/market-snapshot'
 */
const getMarketSnapshot = async (facilityId) => {
    try {
        const {
            data: {data},
        } = await cpServiceGet(`facilities/${facilityId}/market-snapshot`);

        const formattedData = formatFacilityMarketSnapshotResponse(
            data.results
        );

        return formattedData;
    } catch (error) {
        sendSentryException(error);

        throw error;
    }
};

export default getMarketSnapshot;
